import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useStore } from '../../contexts/store-provider';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import { formatMessage } from '../../translations/format-message';
import {
  clearToolBOMFactoryIdFromLocalStorage,
  clearToolManagementFilterFromLocalStorage,
} from '../../helpers/localstorage-helper';
// import './operator.css';

const FactoryAccess = () => {
  const { operatorStore, factoryStore } = useStore();
  const {
    getAssignedProcessListState,
    GetAssignedProcessListService,
    allAssignedTasks,
  } = operatorStore;

  const { GetAllFactoriesService, allAvailableFactories, getAllFactoryState } =
    factoryStore;

  const allAssignedTasksData = allAssignedTasks;

  const getAssignedTaskListServiceHandler = () => {
    // GetAssignedProcessListService(Number(getUserId()));
    GetAllFactoriesService();
  };

  useEffect(() => {
    getAssignedTaskListServiceHandler();
  }, []);

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="factory_access" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="home" />
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  <FormattedMessage id="active_tray_management" />
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-body">
        <div className="operator-box pt-3">
          {getAllFactoryState.inProgress && (
            <FormLoader loading={getAllFactoryState.inProgress} />
          )}
          <div className="row tasks-list">
            {allAvailableFactories
              .filter((f) => f.id > 0)
              .map(({ id, value }) => {
                return (
                  <div
                    key={id}
                    className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3"
                  >
                    {id > 0 && (
                      <NavLink
                        title={formatMessage(value)}
                        to={`${RoutesConstants.AIMSPortal}`}
                        className="task-card factory-card"
                        onClick={() => {
                          const previousTenantId = localStorage.getItem('oms_access_tenant_id');
                          if (previousTenantId !== id.toString()) {
                            clearToolManagementFilterFromLocalStorage();
                            clearToolBOMFactoryIdFromLocalStorage();
                          }
                          localStorage.setItem("oms_access_tenant_id", id.toString());
                        }}
                      >
                        {/* <div className="card-icon">
                          {ShortName.slice(0, 2).toLocaleUpperCase()}
                        </div> */}
                        <div className="card-title">
                          {value}
                          {/* <FormattedMessage id={value} /> */}
                        </div>
                      </NavLink>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(FactoryAccess);
